import useTypedContext from "hooks/useTypedContext";
import FlashContext from "components/FlashMessages/FlashContext";
import DropdownMenuEllipsis from "ds/components/DropdownMenu/Ellipsis";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import { Action } from "types/generated";
import { checkAllowedAction } from "utils/access";

import { ProviderListItemDropdownProps } from "./types";
import { showProviderDeleteConfirmation } from "../ProviderDeleteConfirmation";
import useDeleteProvider from "../useDeleteProvider";

const ProviderListItemDropdown = ({ item, onEdit }: ProviderListItemDropdownProps) => {
  const { reportSuccess, reportError } = useTypedContext(FlashContext);
  const canUpdateProvider = checkAllowedAction(item, Action.TerraformProviderUpdate);
  const canDeleteProvider = checkAllowedAction(item, Action.TerraformProviderDelete);

  const [deleteProvider] = useDeleteProvider({
    refetchQueries: ["GetProviderWithVersions", "GetProviders"],
  });

  const handleDeleteProvider = () => {
    deleteProvider({ id: item.id }, (data) => {
      if (data?.terraformProviderDelete?.deleted) {
        reportSuccess({
          message: `Terraform provider "${data.terraformProviderDelete.id}" was successfully deleted`,
        });
      } else {
        reportError({
          message: "Something went wrong while deleting Terraform provider, please try again.",
        });
      }
    });
  };

  const handleEditProvider = () => {
    onEdit(item);
  };

  const handleDeleteProviderConfirmation = () => {
    showProviderDeleteConfirmation({
      providerId: item.id,
      onConfirm: handleDeleteProvider,
    });
  };

  const isEditVisible = canUpdateProvider.result || canUpdateProvider.message;
  const isDeleteVisible = canDeleteProvider.result || canDeleteProvider.message;

  if (!isEditVisible && !isDeleteVisible) {
    return null;
  }

  return (
    <DropdownMenuEllipsis tooltip="Provider actions">
      {isEditVisible && (
        <DropdownMenuItem
          onAction={handleEditProvider}
          isDisabled={!canUpdateProvider.result}
          tooltip={canUpdateProvider.message}
          isTooltipActive={!!canUpdateProvider.message}
        >
          Edit
        </DropdownMenuItem>
      )}
      {isDeleteVisible && (
        <DropdownMenuItem
          isDisabled={!canDeleteProvider.result}
          tooltip={canDeleteProvider.message}
          isTooltipActive={!canDeleteProvider.result}
          onAction={handleDeleteProviderConfirmation}
          danger
        >
          Delete
        </DropdownMenuItem>
      )}
    </DropdownMenuEllipsis>
  );
};

export default ProviderListItemDropdown;
